/**
 * Retry delays (ms) for `withAutomaticReconnect`, shared by all hubs so that they recover in step.
 * After the last one the connection gives up and `onclose` fires, where the manual retry takes over.
 */
export const signalrReconnectDelays = [0, 2000, 5000, 10000, 30000];
/** Delay (ms) before retrying an initial connection attempt — `withAutomaticReconnect` does not cover those. */
export const signalrInitialRetryDelay = 5000;
